import axios from "axios";
import { API_DOMAIN } from "../../../components/constants";

const headers = () => ({ headers: { accessToken: localStorage.getItem("accessToken") } });
const unwrap = response => {
  if (!response.data?.success) throw new Error(response.data?.message || "Access request failed.");
  return response.data.data;
};

export const fetchCurrentAccess = () => axios.get(`${API_DOMAIN}/auth/access`, headers()).then(unwrap);
export const fetchPermissionCatalogue = () => axios.get(`${API_DOMAIN}/access/permissions`, headers()).then(unwrap);
export const fetchAccessPresets = () => axios.get(`${API_DOMAIN}/access/presets`, headers()).then(unwrap);
export const fetchAssignableAccessPresets = () => axios.get(`${API_DOMAIN}/access/presets/options`, headers()).then(unwrap);
export const fetchAccessPreset = id => axios.get(`${API_DOMAIN}/access/presets/${id}`, headers()).then(unwrap);
export const createAccessPreset = payload => axios.post(`${API_DOMAIN}/access/presets`, payload, headers()).then(unwrap);
export const updateAccessPreset = (id, payload) => axios.patch(`${API_DOMAIN}/access/presets/${id}`, payload, headers()).then(unwrap);
export const deleteAccessPreset = id => axios.delete(`${API_DOMAIN}/access/presets/${id}`, headers()).then(unwrap);
export const fetchAccessAuditLog = (limit = 100, offset = 0) => axios.get(`${API_DOMAIN}/access/audit-log`, { ...headers(), params: { limit, offset } }).then(unwrap);
export const assignUserAccessPreset = (userId, accessPresetId) => axios.patch(`${API_DOMAIN}/auth/users/${userId}/access-preset`, { access_preset_id: accessPresetId }, headers()).then(unwrap);
